import { Node } from 'tiptap';
import { ENodeAlign, EHeadingLevel } from '@/editor/types/enums';

export default class HeadingNode extends Node {
  options: { levels: number[]; defaultLevel: EHeadingLevel; defaultAlign: ENodeAlign };

  get name() {
    return 'heading';
  }

  constructor(options: {
    levels: number[];
    defaultLevel?: EHeadingLevel;
    defaultAlign?: ENodeAlign;
  }) {
    super(options);
  }

  get schema() {
    return {
      attrs: {
        level: {
          default: this.options.defaultLevel || EHeadingLevel.Heading1,
        },
        align: {
          default: this.options.defaultAlign || ENodeAlign.Left,
        },
      },
      content: 'inline*',
      group: 'block',
      defining: true,
      draggable: false,
      parseDOM: this.options.levels.map(level => ({
        tag: level !== EHeadingLevel.Label ? `h${level}` : 'small',
        getAttrs: node => ({
          level,
          align: node.getAttribute('class'),
        }),
      })),
      toDOM: node => [
        node.attrs.level !== EHeadingLevel.Label ? `h${node.attrs.level}` : 'small',
        { class: node.attrs.align },
        0,
      ],
    };
  }
}
